import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router';

import ActionButtons from './ActionButtons';
import SideBar from './SideBar';
import TopBar from './TopBar';

//Authorities
import Authorities from '../../services/AuthoritiesService';

import { logoutAction } from '../../actions/authActions';
import Swal from 'sweetalert2';
//Función principal
const MainContent = ({component: Content, ...props}) => {
    //Tomo los props
    const { title, subtitle, showSubtitle, cssSubtitle, actions, extraItem } = props;
    //Tomo el history
    const history = useHistory();
    //Inicializo el dispath
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    const objectStore = useSelector(state => state.auth.object);
    //Tomo los cambios
    useEffect(() => {
        //Me fijo si existen datos
        if(typeof objectStore !== "undefined"){
            //Reviso los permisos
            if(authorities && !Authorities.hasPermission(authorities, objectStore)){
                //Debo redireccionar
                history.push('/');
            }
        }
    }, [objectStore, authorities]);
    //Métodos para el idle
    const handleOnIdle = event => {
        //Muestro ventana de confirmación de deslogueo
        Swal.fire({
            title: 'Sesión expirada',
            text: 'Su sesión ha expirado por falta de actividad',
            icon: 'info',
            showCancelButton: false,
            // confirmButtonColor: data.confirmButtonColor,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        }).then((result) => {
            //Cierro la sesión, siempre
            handleLogout();
        });
    }
    
    //Tomo los datos del idle
    const { getLastActiveTime, getRemainingTime } = useIdleTimer({
        timeout: 1000 * 60 * 120, //6 Hs
        onIdle: handleOnIdle,
        debounce: 500
    })

    //Manejor el logout
    const handleLogout = () => {
        dispatch( logoutAction(history) );
    }
    //Renderizo
    return (
        <React.Fragment>
            <div id="wrapper">
                
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <TopBar />

                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">
                                    { title }&nbsp;
                                    {
                                        showSubtitle ? (
                                            <small className={cssSubtitle}>
                                                <strong>{ subtitle }</strong>
                                            </small>
                                        ) : null
                                    }
                                    {
                                        extraItem ? (
                                            extraItem
                                        ) : null
                                    }
                                </h1>
                                {
                                    actions ? (
                                        <div className="btn-toolbar mb-2 mb-md-0">
                                            <ActionButtons actions={actions} />
                                        </div>
                                    ) : null
                                }
                            </div>

                            <Content {...props} />
                        </div>
                    </div>

                    <footer className="sticky-footer bg-white">
                        <div className="container my-auto">
                        <div className="copyright text-center my-auto">
                            <span>Oficina de Gestión de Audiencias - Poder Judicial de Tucumán</span>
                            <br/>
                            <small>&copy; 2020 - Dirección de Sistemas</small>
                        </div>
                        </div>
                    </footer>
                </div>
            </div>

        </React.Fragment>
    );
};

export default MainContent;